export default {
  textmessage: {
    SUCCESS: '성공',
    REJECT_PHONE: '수신거부번호 차단',
    RECIPIENT_NOT_FOUND: '발신자 정보 찾을 수 없음.',

    1001: 'Server Busy',
    1002: '수신 번호 형식 오류',
    1003: '발신 번호 형식 오류',
    1019: 'TTL 초과',
    2000: '전송 시간 초과',
    2001: '전송 실패(무선망단)',
    2002: '전송 실패(무선망 > 단말기단)',
    2003: '단말기 전원 꺼짐',
    2004: '통신사와 단말 사이에 메시지 버퍼가 가득 차 전달 불가 상태',
    2005: '음영 지역',
    2006: '메시지 삭제됨',
    2007: '일시적인 단말 문제',
    3000: '전송할 수 없음',
    3001: '가입자 없음',
    3002: '성인 인증 실패',
    3003: '수신 번호 형식 오류 또는 결번(없는 번호)',
    3004: '단말기 서비스 일시 정지',
    3005: '단말기 호 처리(Call processing) 상태, 단말에 도달하지 못함',
    3006: '착신 거절',
    3007: '콜백 URL을 받을 수 없는 단말기',
    3008: '기타 단말기 문제',
    3009: '메시지 형식 오류',
    3010: 'MMS 미지원 단말',
    3011: '서버 오류',
    3012: '스팸',
    3013: '서비스 거부',
    3014: '기타',
    3015: '전송 경로 없음',
    3016: '첨부 파일 크기 제한 실패',
    3017: '발신 번호 변작 방지 서비스에 의거한 번호 형식 오류',
    3018: '발신 번호 변작 방지 서비스에 가입된 휴대폰 개인 가입자 번호',
    3019: 'KISA 또는 미래부에서 모든 고객사에 대하여 차단 처리한 발신 번호',
    4001: '시그니처 형식 오류',
    4002: '발신번호 오류',
    4003: '수신번호 오류',
    4004: '일시적인 단말 문제',
    4005: '가입자 없음',
    4006: '수신자 오류로 인한 실패',
    4007: '통신사 오류 혹은 차단',
    4008: '스팸',
    4009: '일시적 네트워크 오류',
    4010: '비정상적인 전송 패턴으로 인한 실패',
    E900: '기타 발송 오류',
    E911: '첨부파일 확장자가 없는 경우',
    E913: '첨부파일 크기가 0인 경우',
    E915: '중복 메시지',
    E919: '발송 제한 시간인 경우, 메시지 재발송 처리가 금지된 경우',
    E999: '기타 오류',

    4: '파라미터 유효성 검증 실패',
    '-1000': '유효하지 않은 앱키',
    '-1001': '존재하지 않는 앱키',
    '-1002': '사용 종료된 앱키',
    '-1003': '프로젝트에 포함되지 않는 멤버',
    '-1004': '허용되지 않는 IP',
    '-1007': '유효하지 않은 멤버',
    '-1008': '차단된 프로젝트',
    '-9995': '유효하지 않는 API 버전',
    '-9996': '유효하지 않는 contentType. Only application/JSON',
    '-9997': '유효하지 않는 JSON 형식',
    '-9998': '존재하지 않는 API',
    '-9999': '시스템 오류(예기치 못한 오류)',
    '-1005': '유효하지 않는 검색 조건',
    '-1006': '유효하지 않는 발송 메시지(messageType) 유형',

    '-2000': '유효하지 않는 날짜 형식',
    '-2001': '수신자가 비어 있는 경우',
    '-2002': '첨부 파일 이름이 잘못된 경우',
    '-2003': '첨부 파일 확장자가 jpg, jpeg가 아닌 경우',
    '-2004': '첨부 파일이 만료되거나 존재하지 않는 경우',
    '-2005': '첨부 파일 사이즈가 300KB가 넘는 경우',
    '-2006': '템플릿에 설정된 발송 유형과 요청온 발송 유형이 맞지 않는 경우',
    '-2008': '요청 ID(requestId)가 잘못된 경우',
    '-2009': '첨부 파일 업로드 도중 서버 오류로 인해 정상적으로 업로드되지 않은 경우',
    '-2010': '첨부 파일 업로드 유형이 잘못된 경우(서버 오류)',
    '-2011': '필수 조회 파라미터가 비어 있는 경우(requestId 또는 startRequestDate, endRequestdate)',
    '-2012': '상세 조회 파라미터가 잘못된 경우(requestId 또는 mtPr)',
    '-2014': '제목 또는 본문이 비어 있는 경우',
    '-2015': '제목 또는 본문이 초과된 경우',
    '-2016': '수신자가 1,000명이 넘어간 경우',
    '-2017': 'Excel 생성이 실패한 경우',
    '-2018': '수신자 번호가 비어 있는 경우',
    '-2019': '수신자 번호가 유효하지 않는 경우',
    '-2021': '시스템 오류(큐 저장 실패)',
    '-2022': '요청 일시를 현재 시간보다 이전으로 설정한 경우',
    '-2023': '제목 또는 본문에 허용되지 않는 문자(Emoji 등)가 포함된 경우',
    '-2024': 'LMS/MMS로 국제 발송을 전송하는 경우',
    '-2044': '발송 불가능한 국가로 요청을 보낸 경우',
    '-2045': '국제 발송을 차단한 경우',
    '-2046': '차단한 국가에 발송한 경우',
    '-2047': '차단 제한 건수가 넘은 경우',
    '-2048': '국제 발송 본문이 초과된 경우',
    '-2050': '국제 발송 전환에 실패한 경우(전환 가능한 상태가 아님)',
    '-2051': '전환율 기반 차단으로 인해 발송에 실패한 경우',
    '-2052': '조직 당 월별 발송량 초과로 인해 발송에 실패한 경우',
    '-4000': '조회 범위가 한달이 넘어간 경우',
    '-8000': '인증 발송에 인증 문구가 포함되지 않은 경우',
    '-2100': '템플릿 ID가 비어 있는 경우',
    '-2101': '이미 등록된 템플릿 ID',
    '-2102': '템플릿 이름이 비어 있는 경우',
    '-2103': '발신 번호가 비어 있는 경우',
    '-2104': '발송 유형이 비어 있는 경우(0: sms, 1: mms)',
    '-2105': '본문이 비어 있는 경우',
    '-2106': '사용 여부가 잘못된 경우',
    '-2107': '유효하지 않는 템플릿 ID(수정/삭제 시)',

    '-2108': '카테고리 ID가 비어 있는 경우',
    '-2109': '템플릿 ID가 50 글자를 초과하는 경우',
    '-2110': '템플릿이 존재하지 않는 경우',
    '-2111': '유효하지 않는 템플릿 파라미터인 경우',
    '-2112': '최대 등록 가능한 템플릿 개수를 초과한 경우(최대: 1000)',
    '-2114': '제목이 비어 있는 경우',
    '-2115': '제목이 120 글자를 초과하는 경우',
    '-2116': '발송 유형이 SMS일 때 본문 길이가 255 글자를 초과하는 경우',
    '-2117': '발송 유형이 LMS/MMS일 때 본문 길이가 4000 글자를 초과하는 경우',
    '-2043': '템플릿에 등록할 첨부 파일이 이미 다른 템플릿에 등록되어 있는 경우',
    '-2200': '유효하지 않는 카테고리 파라미터(등록 시)',
    '-2201': '유효하지 않는 카테고리 파라미터(수정 시)',
    '-2202': '유효하지 않는 카테고리(카테고리 조회 실패)',
    '-2203': '부모 카테고리가 존재하지 않은 경우',
    '-2204': '사용 여부가 잘못된 경우',
    '-2205': '최상위 카테고리를 삭제하려는 경우',
    '-2206': '존재하지 않은 카테고리인 경우',
    '-2312': '발신 번호가 비어 있거나 미등록 상태',
    '-2313': '차단된 발신 번호',
    '-2700': '유효하지 않는 통계 범위',
    '-2701': '유효하지 않는 통계 검색 파라미터',
    '-2703': '유효하지 않는 통계 세부 범위',
    '-2704': '유효하지 않는 통계 파라미터',
    '-2706': '통계 내부 오류(API 호출 실패)',
    '-6000': '수신 거부 기능을 사용하고 있지 않음',
    '-6001': '수신 거부된 번호',
    '-6003': '본문에 수신 거부 안내 메시지가 없음',
    '-6004': '수신 거부 번호가 비어 있거나 미가입 번호',
    '-7000': '태그 내부 오류(API 호출 실패)',
    '-7001': '유효하지 않는 파라미터',
    '-7002': '.csv 읽기 실패',
  },
  kakao: {
    SUCCESS: '성공',
    REJECT_PHONE: '수신거부번호 차단',
    RECIPIENT_NOT_FOUND: '발신자 정보 찾을 수 없음.',
    UNUSED_KAKAO: '카카오 미사용자 (KKO 전용)',
    RECIPIENT_EMPTY: '수신자번호 EMPTY (SMS 전용)',
    REJECT_KAKAO: `카카오 차단

1. 카카오톡 사용했었다가 탈퇴한사람
2. 카카오톡 가입한적이 한번도 없는 사람
3. 알림톡 수신차단
4. 안드로이드 사용자의경우, "핸드폰 유심과 카카오톡 사용번호"가 다른 사람
5. 활성 사용자가 아닌 경우
6. 카카오톡 최소 사용버전 및 카톡 미지원, 제재 사용자 등

* 활성 사용자
서버와 연결되어 있는 카카오톡 사용자 발송 당일 가입한 사용자를 제외한
최근 7일(168시간) 내에 카카오톡을 사용한 사용자`,
    4: '파라미터 유효성 검증 실패',
    1001: 'Request Body가 Json형식이 아님',
    1002: '허브 파트너 키가 유효하지 않음',
    1003: '발신 프로필 키가 유효하지 않음',
    1004: 'Request Body(JSON)에서 name을 찾을 수 없음',
    1006: '삭제된 발신 프로필(고객센터에게 문의)',
    1007: '차단 상태의 발신 프로필(고객센터에게 문의)',
    1011: '계약 정보를 찾을 수 없음(고객센터에게 문의)',
    1012: '잘못된 형식의 사용자키 요청',
    1013: '유효하지 않은 앱 연결',
    1014: '유효하지 않은 사업자번호',
    1015: '유효하지 않은 app user id 요청',
    1016: '사업자등록번호 불일치',
    1020: '전화번호 or app user id가 유효하지 않거나 미입력 요청',
    1021: '차단 상태의 카카오톡 채널',
    1022: '닫힘 상태의 카카오톡 채널',
    1023: '삭제된 카카오톡 채널',
    1024: '삭제 대기 상태의 카카오톡 채널',
    1025: '채널 제재 상태로 인한 메시지 전송 실패',
    1027: '채널 메시지 제재 상태로 인한 메시지 전송 실패',
    1028: '해당 타겟팅 옵션을 사용할 수 없음',
    1030: '잘못된 파라미터 요청',
    1033: '템플릿 메시지 타입과 chat_bubble_type 파라미터 불일치',

    2001: '메시지 전송 불가(예기치 않은 오류 발생)',
    2003: '메시지 전송 실패(테스트 서버에서 카카오톡 채널을 추가하지 않은 경우)',
    2005: '카카오 내부 시스템 오류로 이미지 정보를 읽어오는 데 실패함',

    3000: '예기치 않은 오류 발생',
    3005: '메시지를 발송했으나 수신 확인이 안 됨(성공 불확실, 서버에는 암호화되어 보관되며 3일 이내 수신 가능)',
    3006: '내부 시스템 오류로 메시지 전송 실패',
    3008: '전화번호 오류',
    3010: '예기치 않은 오류 발생',
    3011: '메시지가 존재하지 않음',
    3013: '메시지가 비어 있음',
    3014: '메시지 길이 제한 오류',
    3015: '템플릿을 찾을 수 없음',
    3016: '메시지 내용이 템플릿과 일치하지 않음',
    3020: `메시지를 발송할 수 없음
알림톡 수신 차단`,
    3021: `메시지를 발송할 수 없음
카카오톡 최소 버전 미지원`,
    3023: '메시지 문법 오류(JSON 형식 오류)',
    3024: '메시지에 포함된 이미지를 전송할 수 없음(이미지주소 또는 링크가 올바르지 않거나 이미지가 규격에 맞지 않음)',
    3025: '변수 글자 수 제한 초과',
    3026: '상담/봇 전환 버튼 extra, event 글자수 제한 초과',
    3027: '메시지 버튼/바로연결이 템플릿과 일치하지 않음',
    3028: '메시지 강조 표기 타이틀이 템플릿과 일치하지 않음',
    3029: '메시지 강조 표기 타이틀 길이 제한 초과(50자)',
    3030: '메시지 타입과 템플릿 강조유형이 일치하지 않음',
    3031: '헤더가 템플릿과 일치하지 않음',
    3032: '헤더 길이 제한 초과(16자)',
    3033: '아이템 하이라이트가 템플릿과 일치하지 않음',
    3034: '아이템 하이라이트 타이틀 길이 제한 초과(이미지 없는 경우 30자, 이미지 있는 경우 21자)',
    3035: '아이템 하이라이트 디스크립션 길이 제한 초과(이미지 없는 경우 19자, 이미지 있는 경우 13자)',
    3036: '아이템 리스트가 템플릿과 일치하지 않음',
    3037: '아이템 리스트의 아이템의 디스크립션 길이 제한 초과(23자)',
    3038: '아이템 요약정보가 템플릿과 일치하지 않음',
    3039: '아이템 요약정보의 디스크립션 길이 제한 초과(14자)',
    3040: '아이템 요약정보의 디스크립션에 허용되지 않은 문자 포함(통화기호/코드, 숫자, 콤마, 소수점, 공백을 제외한 문자 포함)',
    3041: '와이드 아이템 리스트 갯수 최대 최소 갯수 불일치',
    3042: '대표링크가 템플릿과 일치하지 않음',
    3043: '이미지 변수 개수 템플릿 불일치',
    3044: '쿠폰 변수 템플릿 불일치',
    3045: '커머스 정보 변수 템플릿 불일치',
    3046: '부가 정보 최대 길이 제한 오류',
    3047: '커머스 정보 상품명 최대 길이 제한 오류',
    3048: '유효하지 않은 그룹 태그 키 입력',
    3050: '수신동의거부 스펙 (N타입) 미지원 (카카오톡 버전 25.4.0 미만)',
    3051: '케러셀 아이템 리스트 갯수 최소, 최대 갯수 불일치',
    3052: '케러셀 아이템 메시지 길이 초과',
    3053: '캐러셀 템플릿 불일치',
    3054: '캐러셀 버튼 템플릿 불일치',
    3055: '캐러셀 쿠폰 템플릿 불일치',
    3056: '와이드 아이템 리스트 타이틀 길이 제한 오류',
    3057: '캐러셀 커머스 템플릿 불일치',
    3058: '캐러셀 헤더 길이 제한 오류',

    4000: '메시지 전송 결과를 찾을 수 없음',
    4001: '알 수 없는 메시지 상태',
    4100: 'requestId 오류',
    4101: '요청 날짜 오류',
    4102: 'Template 요청 오류',
    4103: '유효한 허브파트너를 찾을 수 없음',
    4104: '유효한 발신 프로필을 찾을 수 없음',
    4110: '유효하지 않은 챗버블 타입 또는 메시지 타입 요청',
    4120: '메시지 요청 페이로드 생성 오류',
    4121: '메시지 발송 대상 오류',
    4122: '메시지 결과 조회 오류',
    4130: 'requestId 패턴 오류',
    4131: '중복 requestId',
    4132: '템플릿 변수 불일치',
    4133: '중단된 템플릿',
    4134: '변경된 템플릿',
    4137: '메시지 요청 실패',
    4138: '브랜드 메시지 메시지 개수 제한',
    4139: '메시지 요청 실패',
    4140: '메시지 요청 실패',
    4141: '메시지 요청 실패',
    4142: '메시지 요청 실패',
    4143: '만료된 요청',
    4144: '본문 길이 제한 (30KB) 초과',
    4156: '최대 발송수 초과',
    4161: '처리중인 메시지',
    9998: '시스템에 문제가 발생하여 담당자가 확인 중(현재 서비스 제공 중이 아님)',
    9999: '시스템에 문제가 발생하여 담당자가 확인 중(시스템에 알 수 없는 오류 발생)',

    '-2000': '특정 필드값이 최대 길이 초과할 경우',
    '-2001': '특정 필드값이 필수 값이 공백인 경우',
    '-2002': '특정 필드값이 NULL일 경우',
    '-2003': '특정 필드값이 최소 길이보다 작을 경우',
    '-2005': '특정 필드값이 제한된 범위 내의 값이 아닌 경우',
    '-2017': '존재하지 않는 발신프로필',
    '-2018': '유효하지 않은 버튼 파라미터',
    '-2019': '템플릿 본문 1,000글자 초과로 실패',
    '-2023': '친구톡 메시지 본문이 400글자 초과할 경우(이미지 첨부)',
    '-2024': '친구톡 메시지 본문이 1,000글자 초과할 경우',
    '-2029': '요청한 메시지가 없거나, 취소할 수 있는 메시지가 없는 경우',
    '-2030': '와이드 이미지 발송 시, 최대 본문 길이 76자 초과한 경우',
    '-2031': '와이드 이미지 발송 시, 최대 버튼 개수 2개 초과한 경우',
    '-2032': '템플릿 제목이 50자를 초과한 경우',
    '-2033': '템플릿 아이템 파라미터가 유효하지 않은 경우',
    '-2034': '템플릿 아이템 하이라이트 파라미터가 유효하지 않은 경우',
    '-2035': '템플릿 헤더가 16자를 초과한 경우',
    '-2036': 'TemplateRepresentLink 파라미터가 유효하지 않은 경우',
    '-2037': '아이템 리스트 포함 템플릿 등록 시 메시지 본문 글자 수가 700자를 초과한 경우',
    '-2500': '대량 발송 요청을 찾을 수 없는 경우',
    '-2501': '요청한 메시지가 없거나, 취소할 수 있는 메시지가 없는 경우',
    '-2502': '발송 실패 설정이 되어 있지 않고, 대체 발송을 요청했을 경우',
    '-2504': '유효하지 않은 바로연결',
    '-2505': '바로연결 포함 발송 시, 최대 버튼 개수 2개를 초과한 경우',

    '-3000': '웹 링크(WL) 버튼 타입의 템플릿일 경우, linkMo 필수 필드',
    '-3001': '이미 존재하는 템플릿 코드 또는 템플릿명',
    '-3002': '필요한 요청 본문(request body) 내용을 읽을 수 없을 경우',
    '-3003': '존재하는 않는 템플릿',
    '-3004': '발송할 템플릿 파라미터 오류',
    '-3005': '템플릿 상태 오류(승인 전 발송 요청 시)',
    '-3006': '버튼 URL은 반드시 http:// 또는 https://를 포함해야 합니다.',
    '-3007': '자유 버튼 타입의 템플릿만 버튼명과 버튼 URL 입력 가능합니다.',
    '-3008': '배송 조회 버튼 타입은 버튼 URL을 입력할 수 없습니다.',
    '-3009': '버튼명이 존재하지 않습니다.',
    '-3010': '등록한 템플릿 본문과 일치하지 않는 경우',
    '-3011': '등록한 템플릿 버튼과 일치하지 않는 경우',
    '-3012': '수정할 수 없는 템플릿 상태(승인/반려 상태만 가능)',
    '-3013': '이미 수정 중인 템플릿이 존재',
    '-3014': '버튼 타입이 올바르지 않은 경우',
    '-3015': 'CBT 기능이 비활성화된 플러스친구일 경우',
    '-3016': '강조 표기형 템플릿은 templateTitle, templateSubtitle 필수 필드',
    '-3017': 'templateSubtitle 은 치환 변수를 사용 불가',
    '-3018': '부가 정보형 템플릿은 templateExtra 필수 필드',
    '-3020': '복합형 템플릿은 templateExtra, templateAd 필수 필드',
    '-3021': 'templateExtra은 치환 변수를 사용 불가',
    '-3024': 'AC 타입 버튼은 채널 추가형 복합형 템플릿만 등록 가능',
    '-3025': 'AC 타입 버튼은 단독으로 사용하거나, 가장 위에 위치해야하는 제약에 어긋난 경우',
    '-3026': 'AC 타입 버튼의 이름은 "채널 추가" 만 등록 가능',
    '-3027': '템플릿 강조 표시 타입 기본(NONE)로 등록 시, templateTitle, templateSubtitle 필드를 등록할 수 없음',
    '-3028': '템플릿 메시지 유형 기본형(BA)일 경우, templateExtra 필드를 등록할 수 없음',
    '-3030': '템플릿 메시지 유형 채널 추가형(AD)일 경우, templateExtra 필드를 등록할 수 없음',
    '-3032': '템플릿 강조 표시 타입 이미지형(IMAGE)일 경우, templateImageName, templateImageUrl 필드 필수값',
    '-3033': '버튼 또는 바로연결이 템플릿에 등록되지 않았을 경우',
    '-3034': '삭제할 템플릿이 3일이내 발송 이력이 있을 경우',
    '-3035': `템플릿 강조 표시 타입 아이템리스트형(ITEM_LIST)로 등록 시,
 templateHeader, templateImageName, templateImageUrl, templateItem, templateItemHighlight 필드 중 
1개 이상 필수로 포함`,
    '-3036': '템플릿 강조 표시 타입 아이템리스트형(ITEM_LIST)로 등록 시, 보안 템플릿으로 등록할 수 없음',
    '-3037': 'templateItem list의 title은 치환 변수를 가질 수 없음',
    '-3038': 'templateItem summary의 title은 치환 변수를 가질 수 없음',
    '-3039': 'templateItem summary은 templateItem list없이 존재할 수 없음',
    '-3040': '아이템하이라이트의 title은 최대 21글자, description은 최대 13글자',
    '-3041': 'imageUrl은 http:// https:// 프로토콜을 반드시 포함해야 함',
    '-3042': 'templateHeader이 템플릿과 일치하지 않는 경우',
    '-3043': 'templateItem 또는 templateItemHighlight이 템플릿과 일치하지 않는 경우',
    '-3044': '비지니스폼(BF) 타입 버튼은 단독으로 사용하거나, 가장 위에 위치해야하는 제약에 어긋난 경우',
    '-3045': `비지니스폼(BF) 타입의 name이 ""톡에서 예약하기"", ""톡에서 설문하기"", ""톡에서 응모하기"" 이 아닐 경우,
또는 등록되지 않은 bizFormKey일 경우`,
    '-3046': 'templateRepresentLink이 템플릿과 일치하지 않는 경우',
    '-3047': '템플릿 등록 시 서체 스타일을 적용하려고 한 경우 (서체 스타일은 발송 시점에 적용 가능합니다.)',
    '-3048': '템플릿 파라미터는 1000자를 넘을 수 없습니다.',
    '-3049': '템플릿 파라미터가 템플릿과 일치하지 않습니다.',
    '-3050': '템플릿 메시지 타입(AD/MI)은 AC 타입의 버튼을 가져야 합니다.',
    '-3051': 'TN 버튼 이름은 \'전화 연결\', \'고객센터 연결\', \'상담원 연결\' 중 하나여야 합니다.',
    '-3052': 'TN 버튼에는 telNumber 필드가 필수입니다.',
    '-3053': '유효하지 않은 전화번호 형식입니다. 숫자와 하이픈만 사용 가능하며, 최대 14자까지 입력할 수 있습니다.',
    '-3100': '템플릿 요청/승인 상태의 경우 comment를 추가할 수 없음',
    '-3101': '바로 연결 이름이 존재하지 않는 경우',
    '-3102': '바로 연결은 치환자를 포함할 수 없음',
    '-3103': '버튼 혹은 바로 연결의 형식이 올바르지 않은 경우 (json 형식이 아니거나, escape 되지 않은 문자가 섞여있음)',
    '-3200': '와이드 아이템리스트에 name이 누락된 경우',
    '-3201': '와이드 아이템리스트에 image가 누락된 경우',

    '-3202': '와이드 아이템리스트에 linkMo가 누락된 경우',
    '-3203': '와이드 아이템리스트는 3~4개의 크기의 list와 header가 필수적',
    '-3204': '캐러셀에 header가 누락된 경우',
    '-3205': '캐러셀에 message가 누락된 경우',
    '-3206': '캐러셀에 attachment가 누락된 경우',
    '-3207': '캐러셀에 image가 누락된 경우',
    '-3208': '캐러셀에 2~10개의 크기의 list가 필수, 인트로를 포함한 캐러셀 커머스형의 경우 1~10개의 크기의 list가 필수',
    '-3209': '캐러셀의 tail에 linkMo가 누락된 경우',
    '-3210': '쿠폰은 title과 description이 필수적',
    '-3211': `친구톡 텍스트/이미지 타입 친구톡 메시지의 경우 쿠폰의 description은 12자를 초과할 수 없고, 
FW/FL 타입의 경우 18자를 초과할 수 없음`,
    '-3212': '쿠폰의 title 내용이 유효하지 않은 경우',
    '-3213': '쿠폰은 모바일 링크 혹은 채널형 ios/android 링크가 필수적',
    '-3215': '와이드 아이템리스트와 캐러셀은 광고 타입일 경우에만 사용 가능',
    '-3216': '와이드 아이템리스트의 첫번째 아이템 title은 25자를 초과할 수 없고, 2 ~ 4 번째 아이템 title은 30자를 초과할 수 없음',
    '-3217': `친구톡 텍스트/이미지 타입의 경우 버튼은 5개를 초과할 수 없고, 쿠폰이 포함된 경우 4개를 초과할 수 없음, 
와이드 이미지/와이드 아이템 리스트인 경우 버튼은 2개를 초과할 수 없음, 
프리미엄 동영상 타입의 경우 버튼은 1개를 초과할 수 없음, 커머스형의 경우 버튼은 1 ~ 2개 사이여야 함`,
    '-3218': '친구톡 videoUrl이 유효하지 않음',
    '-3219': '친구톡 content 최대 길이를 초과함. 프리미엄 동영상 타입의 경우 content 최대 길이가 76자',
    '-3220': '친구톡 header 최대 길이를 초과함. 프리미엄 동영상 타입의 경우 header 최대 길이가 20자',
    '-3221': '캐러셀 피드 타입은 캐러셀 인트로를 사용할 수 없음',
    '-3222': '캐러셀 피드 타입은 부가 정보 필드를 사용할 수 없음',
    '-3223': '캐러셀 피드 타입은 커머스를 사용할 수 없음',
    '-3224': '캐러셀 커머스 타입은 header와 message 필드를 사용할 수 없음',
    '-3225': `캐러셀 버튼이 유효하지 않음. 캐러셀 피드 타입의 경우 버튼은 2개를 초과할 수 없음. 
캐러셀 커머스 타입의 경우 버튼은 1 ~ 2개여야 함`,
    '-3226': '커머스에 discountPrice 필드가 존재하면 discountRate 혹은 discountFixed 필드가 필수',
    '-3297': '자유형 발송 시 M, N 타겟팅을 설정할 수 없습니다.',
    '-3298': '타겟팅 정보가 설정되지 않았습니다.',
    '-3299': `커머스 변수는 지정된 조합으로만 사용해야 합니다: 
['regularPrice'], ['regularPrice', 'discountPrice', 'discountRate'], ['regularPrice', 'discountPrice', 'discountFixed']`,
    '-3300': '수신거부 처리된 번호를 찾을 수 없습니다.',
    '-3301': '수신거부한 사용자가 포함되어 있습니다.',
    '-3303': '필수 입력값이 누락되었습니다.',
    '-3304': '입력값이 유효한 범위를 벗어났습니다. 지정된 범위 내의 값을 입력해주세요.',
    '-3305': '선택한 말풍선 타입에는 특정 필드를 사용할 수 없습니다.',
    '-3306': '커머스 타입 메시지에는 버튼이 반드시 포함되어야 합니다.',
    '-3307': '버튼 링크 타입에 따라 필수 입력 항목이 누락되었습니다.',
    '-3308': '버튼 링크 타입에 따라 여러 필수 입력 항목이 누락되었습니다.',
    '-3309': '템플릿에 앱링크(AL) 사용 시, schemeAndroid, schemeIos, LinkMo 중 최소 두 가지를 입력해야 합니다.',
    '-3310': '웹링크 URL(linkMo/linkPc)은 \'http://\' 또는 \'https://\'를 포함해야 합니다.',
    '-3311': '메시지 타입이 텍스트 또는 이미지인 경우, 채널 추가(AC) 버튼은 첫 번째 버튼이어야 합니다.',
    '-3312': '메시지 타입이 텍스트 또는 이미지가 아닌 경우, 채널 추가(AC) 버튼은 마지막 버튼이어야 합니다.',
    '-3313': `쿠폰 URL 정보가 잘못되었습니다. 
기본 쿠폰 사용 시 linkMo 필드가, 채널 쿠폰 URL 사용 시 schemeAndroid 또는 schemeIos 필드가 필요합니다.`,
    '-3314': '쿠폰 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3315': '쿠폰 제목이 유효하지 않습니다.',
    '-3316': '커머스 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3317': '비디오 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3318': '비디오 URL이 유효한 형식이 아닙니다.',
    '-3319': '이미지 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3320': '캐러셀 아이템 개수가 허용된 범위(최소/최대값)를 벗어났습니다.',
    '-3321': '캐러셀 헤더에 링크 입력 시, 모바일 링크(linkMo)는 필수입니다.',
    '-3322': '캐러셀 헤더 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3323': '캐러셀 푸터 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3324': '템플릿 변수값이 잘못되었습니다.',
    '-3325': '아이템(상품) 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3326': '이미지 URL은 \'http://\' 또는 \'https://\'를 포함해야 합니다.',
    '-3327': '이미지 링크 URL은 \'http://\' 또는 \'https://\'를 포함해야 합니다.',
    '-3328': '허용되지 않는 버튼 타입입니다.',

    '-3329': '친구톡 업그레이드 API 사용 권한이 없는 앱키입니다.',
    '-3330': '채널 추가 버튼이 없는 세로 버튼 배열 시, 봇 전환(BF) 버튼은 첫 번째여야 합니다.',
    '-3331': '허용되지 않는 버튼 이름입니다.',
    '-3332': '캐러셀 커머스 아이템 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3333': '캐러셀 커머스 아이템에 허용되지 않는 정보가 포함되어 있습니다.',
    '-3334': '캐러셀 일반 아이템 정보 입력 시 필수 항목이 누락되었습니다.',
    '-3335': '캐러셀 일반 아이템에 허용되지 않는 정보가 포함되어 있습니다.',
    '-3336': '채널 추가 버튼이 있는 세로 버튼 배열 시, 봇 전환(BF) 버튼은 두 번째여야 합니다.',
    '-3337': '채널 추가 버튼이 없는 가로 버튼 배열 시, 봇 전환(BF) 버튼은 오른쪽(두 번째)이어야 합니다.',
    '-3338': '채널 추가 버튼이 있는 가로 버튼 배열 시, 봇 전환(BF) 버튼은 왼쪽(첫 번째)이어야 합니다.',
    '-3339': '080 인증번호 입력시 080 수신거부번호는 필수 값입니다.',
    '-3340': '잘못된 080 수신거부번호',
    '-3341': '잘못된 080 인증번호',
    '-3342': '마케팅 수신동의 증적자료 업로드 실패',
    '-3343': 'M/N 타입 사용 신청 실패',
    '-3344': '이미지 변경 파라미터 갯수가 템플릿 이미지 갯수와 일치하지 않음',
    '-3345': '080 수신거부정보가 유효하지 않음',
    '-4003': '조회 범위는 한 달 초과',
    '-4004': '존재하지 않는 앱키',
    '-4005': '사용 종료 상태의 앱키',
    '-4007': '파일 사이즈 초과 초과',
    '-4009': '유효하지 않은 파일 확장자',
    '-4015': '유효하지 않은 요청 ID(requestId)',
    '-4025': '템플릿 업로드 시, 최대 20개를 초과한 경우',
    '-4026': '템플릿 업로드 파일의 헤더가 유효하지 않은 경우',
    '-4027': '버튼 길이가 최대치인 상태로 채널 추가형 전환을 하려고 하는 경우',
    '-4028': '승인되지 않은 템플릿으로 채널 추가형 전환을 하려고 하는 경우',
    '-4029': '발신 프로필 마케팅 수신 동의가 활성화되지 않은 경우',
    '-4101': '유효하지 않은 통계 조회 파라미터',
    '-4103': '조회 시, 발송 요청 시작 시간/발송 요청 끝 시간값이 없을 경우',
    '-4200': '유효하지 않은 대체 발송 메시지',
    '-7000': '벤더 요청 API 실패',
    '-8000': '이미지 시퀀스(imageSeq)가 없는 경우',
    '-8001': '이미지 파일이 정상적이지 않은 경우',
    '-8002': `이미지를 찾을 수 없는 경우. 캐러셀 피드 타입의 경우 캐러셀 타입 이미지를 사용해야 함, 
캐러셀 커머스 유형의 경우 캐러셀 커머스 타입 이미지를 사용해야 함, 커머스 유형의 경우 일반 이미지 타입을 사용해야 함`,
    '-8003': '이미지 삭제에 실패하는 경우',
    '-8004': 'createUser 필드 최대 100자를 초과한 경우',
    '-8005': '이미지 업로드 시 프로젝트에 등록된 플러스친구가 없는 경우',
    '-8006': '인증 메시지 발송 시, 템플릿 내용에 인증 문구가 없는 경우',
    '-8008': '메시지 내용에 금칙어가 포함된 경우',
    '-8010': '네트워크 등의 문제로 이미지 파일 업로드 실패',
    '-8011': '존재하지 않는 이미지 유형',
    '-9995': 'fade-out된 버전의 API를 호출했을 경우',
    '-9996': 'Content-type이 application/json가 아닐 경우',
    '-9997': '적절하지 않은 요청으로 인한 실패',
    '-9998': '존재하지 않는 API',
    '-9999': '시스템 오류',
  },
};
